export enum Language {
    NL,
    EN,
    ES,
    FR
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/language.ts